/**
 * Every outward-facing URL and bit of site metadata lives here.
 *
 * The landing page, the JSON-LD structured data, and the sitemap all describe
 * the same product, and search engines penalise it when they disagree. Keeping
 * one source means a changed app-store link or tagline cannot drift between the
 * visible copy and the machine-readable copy.
 */

export const SITE_URL = "https://tbtfencing.com";

export const SITE_NAME = "Touch by Touch";

export const TAGLINE = "High school and college fencing made easy";

export const DESCRIPTION =
    "Free fencing team management and live dual meet scoring for high school and college coaches. " +
    "Build rosters, score bouts in real time, and broadcast meets to spectators at home.";

export const CONTACT_EMAIL = "tbt@redpandafencing.org";

export const SUBSTACK_URL = "https://tbtfencing.substack.com/";

export const SPONSOR = "Red Panda Fencing Inc.";

/**
 * The two divisions are near-identical products with separate web apps and
 * separate app-store listings, so almost everything on the page renders twice.
 */
export const DIVISIONS = [
    {
        key: "hs",
        label: "High School",
        website: "https://hs.tbtfencing.com",
        ios: "https://apps.apple.com/us/app/touch-by-touch/id1530755543",
        android: "https://play.google.com/store/apps/details?id=live.touchbytouch",
    },
    {
        key: "college",
        label: "College",
        website: "https://college.tbtfencing.com",
        ios: "https://apps.apple.com/us/app/touch-by-touch-college-fencing/id6451499719",
        android: "https://play.google.com/store/apps/details?id=live.touchbytouchcollege",
    },
] as const;
